import type { OAISchema } from '~/types/openapi';

type Props = {
  categories: OAISchema['PlacementEventResponse']['categories'];
};

export function EventCategoryList({ categories }: Props) {
  if (!categories?.length) return null;

  return (
    <section className="grid grid-cols-5 gap-x-8 gap-y-16 px-20 py-16">
      {categories?.map((category) => {
        return (
          <button
            className="flex items-start"
            key={category.landingUrl}
            type="button"
            onClick={() => window.open(category.landingUrl, '_blank')}
          >
            <img src={category.imageUrl} alt="카테고리" />
          </button>
        );
      })}
    </section>
  );
}
